<!-- The cell's DOM already holds the full text, so the tooltip stays silent for screen readers. -->
<div
  class="table-cell tw:outline-none tw:focus-visible:outline-solid tw:focus-visible:outline-2 tw:focus-visible:-outline-offset-2 tw:focus-visible:outline-primary"
  #cell
  [fr8botUiTooltip]="fullText()"
  [uiTooltipDisabled]="!truncated()"
  [uiTooltipAnnounce]="false"
  [attr.tabindex]="truncated() ? 0 : null"
  [attr.data-handles-tap]="truncated() ? '' : null"
>
  <span class="table-cell__overflow-container" #content>
    <ng-content></ng-content>
  </span>
</div>
